export * from './role-permission.component';